module.exports = __webpack_public_path__ + "img/logo.cc520321.png";